module.exports = __webpack_public_path__ + "img/zkzg.b8a4d515.png";